import React, { useState, useEffect } from 'react';
import './InviteFriends.css';
import { listGroups as v2ListGroups } from './v2Api';

const InviteFriends = ({ user, active }) => {
  const [showGroups, setShowGroups] = useState(false);
  const [groups, setGroups] = useState([]);
  const domain = window.location.hostname;

  useEffect(() => {
    const fetchGroups = async () => {
      if (user) {
        try {
          const { groups } = await v2ListGroups(user);
          setGroups((groups || []).map(g => ({ name: g.name, link_key: g.link_key })));
        } catch (error) {
          console.error('Error fetching groups (v2):', error);
        }
      }
    };

    fetchGroups();
  }, [user]);

  const handleInviteClick = () => {
    setShowGroups(true);
  };

  const handleCopyClick = (groupName, groupLink) => {
    const textToCopy = `Hey! We can now select cool Burning Man events and share our plans! Join the me and ${groupName}: ${groupLink}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      alert('Invitation copied to clipboard, send it to your friends!');
    }, (err) => {
      console.error('Error copying text: ', err);
    });
  };

  return (
    <div className="invite-friends-container">
      {showGroups ? (
        <div className="groups-list">
          {groups.map((group, index) => (
            <div key={index} className="group-item">
              <span>
                Group {group.name}: <a href={`https://${domain}/groups/${group.link_key}`} target="_blank" rel="noopener noreferrer">{`https://${domain}/groups/${group.link_key}`}</a>
              </span>
              <button className="copy-button" onClick={() => handleCopyClick(group.name, `https://${domain}/groups/${group.link_key}`)}>Copy invitation</button>
            </div>
          ))}
        </div>
      ) : (
        <button
          className={`invite-button ${active ? 'active-button' : 'secondary-button'}`}
          onClick={handleInviteClick}
        >
          Invite friends
        </button>
      )}
    </div>
  );
};

export default InviteFriends;
